import { render, staticRenderFns } from "./TCF.vue?vue&type=template&id=b618fbec&scoped=true"
import script from "./TCF.vue?vue&type=script&lang=js"
export * from "./TCF.vue?vue&type=script&lang=js"
import style0 from "./TCF.vue?vue&type=style&index=0&id=b618fbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b618fbec",
  null
  
)

export default component.exports